export default {

    methods: {

      async getMultiTableConfig(name) {
          var configuration = {
            election_night_processing:{
                undo: true,
                table1: 'election_processing_race_stage',
                table2: 'election_processing_candidate_results',
                orderBy1: 'race_id, date,stage_id',
                orderBy2: 'rcv_round, candidate_name',
                sortDirection1: 'asc',
                sortDirection2: 'asc',
                related_field_name: 'Stage ID',
                related_field_variable: 'stage_id',
                related_field_table_1: 'stage_id',
                heading_table_1 : 'Race and Stage',
                heading_table_2: 'Candidates and Results',
                page_title: 'Election Night Processing',
                workflow2: 'csr_workflow',
                workflow1: 'certified_workflow',
                display_table_links: true,
                link_table_1: 'stages',
                link_table_2: 'candidate_stage_results',
                link_field: 'stage',
                link_button_1: 'Stages Table',
                link_button_2: 'CSR Table'
            }                   
        }
          if (configuration[name]){
              return configuration[name]
          }
      }
    }
     
};
